var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.is_novelty)?_c('b-badge',{attrs:{"pill":"","variant":'success'}},[_vm._v("\n    Новинка\n")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }